import React from 'react';
import { colors } from 'globalStyle';
import { Text } from 'components/Texts';
import {
  Box, Grid, Tooltip, makeStyles,
} from '@material-ui/core';
import { findSocialImpactByValue } from 'types';
import styled from 'styled-components';

import ProjectTextContent from './ProjectTextContent';

const useTooltipStyles = makeStyles({
  tooltip: {
    backgroundColor: 'transparent',
  },
});

export default function ProjectSDG({ ods, isDesktop, ...props }) {
  const tooltipStyles = useTooltipStyles();
  return (
    <ProjectTextContent
      text={ods && (() => (
        <Grid container direction="column" justify="center">
          Los Objetivos de Desarrollo Sostenible (ODS) u Objetivos Globales son 17 objetivos
          globales interconectados diseñados para ser un “plan para lograr un futuro mejor
          y más sostenible para todos”.
          <Grid container justify="center" spacing={2}>
            {ods.map((item) => (
              <Tooltip
                key={item}
                classes={tooltipStyles}
                title={isDesktop && (
                  <DescriptionContainer isDesktop={isDesktop}>
                    <Text size={12} align="start">
                      {findSocialImpactByValue(item)?.description}
                    </Text>
                  </DescriptionContainer>
                )}
              >
                <ODSContainer item>
                  <Box
                    alt={item}
                    component="img"
                    marginTop="40px"
                    position="relative"
                    borderRadius="10px"
                    height={isDesktop ? '110px' : '80px'}
                    src={findSocialImpactByValue(item)?.image}
                  />
                </ODSContainer>
              </Tooltip>
            ))}
          </Grid>
        </Grid>
      ))}
      noLimit
      isDesktop={isDesktop}
      {...props}
    />
  );
}

const ODSContainer = styled(Grid)({
  position: 'relative',
});

const DescriptionContainer = styled(Box)`
  margin-top: -20px;
  margin-bottom: -20px;
  border-radius: 10px;
  padding: 28px 16px 28px 20px;
  background: ${colors.background.GRAY_3};
  width: ${(props) => (props.isDesktop ? '200px' : '80px')};
`;
